<template>
  <nav class="flex items-center justify-between flex-wrap bg-green-400 p-6">
    <div class="flex items-center flex-no-shrink text-white mr-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        class="text-main w-8 mr-2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
        />
      </svg>
      <router-link :to="{ path: '/' }">
        <span class="font-bold text-xl tracking-tight">CookBook</span>
      </router-link>
    </div>
    <div>
      <button
        class="inline-block text-sm px-4 py-2 font-bold leading-none border rounded text-white border-white hover:text-main hover:bg-white outline-none focus:outline-none"
        @click="onOpenModal()"
      >
        Add new recipe
      </button>
    </div>
  </nav>
</template>

<script>
import * as actions from "@/store/modules/modal/types/actions";
import { mapActions } from "vuex";

export default {
  name: "RecipeItem",
  methods: {
    ...mapActions("modal", {
      openModal: actions.OPEN_MODAL,
    }),
    onOpenModal: function(recipeId) {
      this.openModal(recipeId);
    },
  },
};
</script>
